import { useRef } from "react";
import type { VirtuosoHandle as ReactVirtuosoHandle } from "react-virtuoso";

export { Virtuoso } from "react-virtuoso";

type VirtuosoHandle = ReactVirtuosoHandle;

/**
 * This map tracks the index of items by their unique identifier.
 * It is used to quickly find the index of an item in the list.
 * This is particularly useful for large lists where performance is a concern.
 */
type VirtuosoIndexMap = Map<string, number>;

type VirtuosoRef = React.RefObject<VirtuosoHandle | null>;
type VirtuosoIndexMapRef = React.RefObject<VirtuosoIndexMap | null>;

export type VirtuosoHandles = {
	ref: VirtuosoRef;
	indexMap: VirtuosoIndexMapRef;
};

export function useVirtuoso(): VirtuosoHandles {
	const ref = useRef<VirtuosoHandle | null>(null);
	const indexMap = useRef<VirtuosoIndexMap | null>(new Map());

	return {
		ref,
		indexMap,
	};
}
